import Login from "../screens/nonAuth/Login";
import Register from "../screens/nonAuth/Register";
import Dashboard from "../screens/auth/Dashboard";
import Home from "../screens/users/Home";
import About from "../screens/users/About";
import Contact from "../screens/users/Contact";
import ForgotPassword from "../screens/nonAuth/ForgotPassword";
import Profile from "../screens/auth/Profile";
import Products from "../screens/auth/Products";
import Services from "../screens/auth/Services";
import ServicesDetails from "../screens/users/ServicesDetails";
import ProductsDetail from "../screens/users/ProductsDetail";
import Blogs from "../screens/users/Blogs";
import AdninBlogs from "../screens/auth/AdninBlogs";
import BlogDetails from "../screens/users/BlogDetails";
import ChooseYourPlan from "../screens/users/ChooseYourPlan";
import AddVideoesReview from "../screens/auth/AdminVideoesReview";
import VideoReview from "../screens/users/VideoReview";
import AdminVideoesReview from "../screens/auth/AdminVideoesReview";
import AdminCreateTestimonials from "../components/AdminSideComponents/Modals/AdminCreateTestimonials";

export const authRoutes = [
  {
    path: "/dashboard",
    component: <Dashboard />,
  },
  {
    path: "/products",
    component: <Products />,
  },
  {
    path: "/all-blogs",
    component: <AdninBlogs />,
  },
  {
    path: "/services",
    component: <Services />,
  },
  {
    path: "/profile",
    component: <Profile />,
  },
  {
    path: "/add-videoes",
    component: <AdminVideoesReview />,
  },
  {
    path: "/admin-create-testimonials",
    component: <AdminCreateTestimonials />,
  },
];

export const nonAuthRoutes = [
  {
    path: "/admin-login",
    component: <Login />,
  },
  {
    path: "/register",
    component: <Register />,
  },
  {
    path: "/forgot-password",
    component: <ForgotPassword />,
  },
];

export const userRoutes = [
  {
    path: "/",
    component: <Home />,
  },
  {
    path: "/about",
    component: <About />,
  },
  {
    path: "/contact",
    component: <Contact />,
  },
  {
    path: "/our-services",
    component: <ServicesDetails />,
  },
  {
    path: "/our-services/:id",
    component: <ServicesDetails />,
  },
  {
    path: "/our-products",
    component: <ProductsDetail />,
  },
  {
    path: "/our-products/:id",
    component: <ProductsDetail />,
  },
  {
    path: "/blogs",
    component: <Blogs />,
  },
  {
    path: "/blog-Details/:id",
    component: <BlogDetails />,
  },
  {
    path: "/plan-details",
    component: <ChooseYourPlan />,
  },
  {
    path: "/review",
    component: <VideoReview />,
  },
];
